import React from "react";
import Spritesheet from 'react-responsive-spritesheet';
import TextBox from "../../TextBox";

import img from './images/1.png';

const width = 5751 / 15;
const height = 300 / 1;

const Window = (props) => {

    return <div className="position-relative" >
        <div className={`mb-1 d-inline-block`} >
            <Spritesheet
                image={img}
                widthFrame={width}
                heightFrame={height}
                steps={15}
                startAt={1}
                endAt={15}
                fps={15}
                autoplay={true}
                loop={true}
            />
        </div>
        <TextBox {...props} />
    </div >
}

export default Window;